/**
 * Determines whether the checked scope is listed in the actual scope.
 */
export function isScopeListed(checkedScope: string, actualScope: string): boolean {
  const checkedScopeList = checkedScope.trim().toLowerCase().split(/\s+/);
  const actualScopeList = actualScope.trim().toLowerCase().split(/\s+/);
  return checkedScopeList.every((scope) => actualScopeList.indexOf(scope) !== -1);
}
